module.exports = __webpack_public_path__ + "static/media/canela-light.9b723997.woff";